import { useEffect, useState } from 'react'

import { EVENT_NAME_CHANGE } from '../constants/event'
import { STORAGE_EVENT } from '../constants/storage'
import { THEME_DARK_MEDIA_QUERY } from '../constants/themeMode'
import { ThemeMode } from '../context'
import {
  applyTheme,
  getInitialForcedTheme,
  getIsSystemThemeDark,
  getStoredThemeMode,
  getThemeByMode,
  isThemeModeStorageKey,
  storeThemeMode,
} from '../utils/themeMode'

function ThemeModeProvider({ children }) {
  const [mode, setMode] = useState(getStoredThemeMode)
  const [isSystemDark, setIsSystemDark] = useState(getIsSystemThemeDark)
  const [forcedTheme, setForcedTheme] = useState(getInitialForcedTheme)

  const theme = forcedTheme ?? getThemeByMode(mode, isSystemDark)

  function changeMode(nextMode) {
    storeThemeMode(nextMode)
    setMode(nextMode)
  }

  useEffect(() => {
    applyTheme(theme)
  }, [theme])

  useEffect(() => {
    const media = window.matchMedia(THEME_DARK_MEDIA_QUERY)

    function handleSystemThemeChange(event) {
      setIsSystemDark(event.matches)
    }

    media.addEventListener(EVENT_NAME_CHANGE, handleSystemThemeChange)

    return () => {
      media.removeEventListener(EVENT_NAME_CHANGE, handleSystemThemeChange)
    }
  }, [])

  useEffect(() => {
    function handleStorage(event) {
      if (isThemeModeStorageKey(event.key)) {
        setMode(getStoredThemeMode())
      }
    }

    window.addEventListener(STORAGE_EVENT, handleStorage)

    return () => {
      window.removeEventListener(STORAGE_EVENT, handleStorage)
    }
  }, [])

  const value = { changeMode, mode, setForcedTheme, theme }

  return <ThemeMode value={value}>{children}</ThemeMode>
}

export default ThemeModeProvider
